// extracted by mini-css-extract-plugin
export var label = "_4g-1";
export var reminder = "_4g-0";